import React, { useState } from "react";
import Navbar from "../components/mainNavBar";
import HomeFooter from "../components/homefooter";
import { useNavigate } from "react-router-dom";

export default function Aboutus() {
  const navigate = useNavigate();
  const [selectedMember, setSelectedMember] = useState(null);

  const team = [
    {
      id: 1,
      name: "Kunal Sondhi",
      role: "President and Chief Product Officer",
      photo: "/json-media/img/team/KunalSondhi.webp",
      details:
        "Lead product engineering and user experience teams to successfully create and sell uniquely positioned offerings for B-Raja (video streaming platform), Rawcubes (data management software) and Infosys (consulting) firms. In his professional career, he has overseen all product management activities relating to research, design, feature prioritization, and product marketing. He brings a natural tendency to be curious to ensure the creation of quality products that customers would want to buy.",
    },
    {
      id: 2,
      name: "Joshua Kanter",
      role: "Chief Data & Analytics Officer",
      photo: "/json-media/img/team/JoshuaKanter.webp",
      details:
        "With over 25 years of expertise in marketing, strategy, and business development, Joshua has a proven track record of translating complex data into actionable strategies, enhancing customer experiences, and driving measurable business results. Joshua has successfully led high-performance teams across diverse industries, including retail, financial services, travel & hospitality and technology. He holds an MBA from The Wharton School and a BA in Psychology from Harvard University. Joshua is passionate about mentoring and community development, and his strategic vision and operational excellence are invaluable to ConvertML's growth and innovation.",
    },
    {
      id: 3,
      name: "Deepak Sondhi",
      role: "Chairman",
      photo: "/json-media/img/team/DeepakSondhi.webp",
      details:
        "Scaled $200M+ different business transformation efforts across prominent Fortune 500 companies in the US, Latin America, Europe, India, and the Asia-Pacific region. He brings industry thought leadership and extensive project experience. He has helped several companies formulate and roll out complex projects, including project conceptualizing, roll-out, and scaling.",
    },
    {
      id: 4,
      name: "Hardev Sahu",
      role: "Vice Chairman",
      photo: "/json-media/img/team/HardevSahu.webp",
      details:
        "Career spans 25 years of leadership in both established companies and entrepreneurship. Hardev's valiant and ethical approach to work and life has unprecedented success in a diverse business domain that includes information technology, marble and granite mining, healthcare, e-governance, and hospitality.",
    },
  ];

  return (
    <>
      <Navbar />

      <main className="pagebg">
        <section className="hero">
          <div className="hero-text padding">
            <h1>About Us</h1>
            <p>
              Just a bunch of data, AI & analytics nerds who happen to have a
              passion for market research
            </p>
          </div>
          <div className="hero-image">
            <img
              className="img-responsive"
              alt="Generative Insight Research"
              src="/json-media/img/aboutusbanner.webp"
            />
          </div>
        </section>
        <section className="team-members" style={{ paddingTop: "10px" }}>
          <h2>Our Vision</h2>
          <p>
            At Generative Insight, our vision is to make deep, accurate consumer
            understanding available instantly to every organization. We believe
            leaders should never have to choose between speed and rigor — modern
            insight should deliver both.
          </p>
          <br />
          <p>
            We aim to redefine how research is done by combining rich data,
            advanced analytics, and AI-driven segment intelligence. Our goal is
            simple: empower teams to explore questions freely, uncover clarity
            quickly, and make confident decisions grounded in real consumer
            truth.
          </p>
        </section>
        <section className="founders-section">
          <h2 className="founders-title">Meet Our Founders</h2>

          <div className="founders-grid">
            {team.map((member) => {
              const isExpanded = selectedMember === member.id;
              const preview = member.details.slice(0, 120);

              return (
                <div key={member.id} className="founder-card">
                  <img
                    src={member.photo}
                    alt={member.name}
                    className="founder-photo"
                  />

                  {/* White center floating box */}
                  <div className="founder-topbox">
                    <h3 className="founder-name">{member.name}</h3>
                    <p className="founder-role">{member.role}</p>
                  </div>

          
                  <div className="founder-details">
                    <p>{isExpanded ? member.details : preview + "..."}</p>

                    <button
                      className="more-btn"
                      onClick={() =>
                        setSelectedMember(isExpanded ? null : member.id)
                      }
                    >
                      {isExpanded ? "Show Less" : "Read More"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </main>

      <HomeFooter />
    </>
  );
}
